import { CALL_API } from '../../../middlewares/api';

import { STORAGE_KEY_CF_TOKEN } from '../../../constants/storage';
import { REQUEST_REGISTER, SUCCESS_REGISTER, FAILURE_REGISTER } from './constants';

import { updateInfos } from '../../account/actions';

export const registerUser = (form, callback) => {
    const cloudflareCaptcha = sessionStorage.getItem(STORAGE_KEY_CF_TOKEN);

    return {
        [CALL_API]: {
            endpoint: '/auth/register',
            types: [REQUEST_REGISTER, SUCCESS_REGISTER, FAILURE_REGISTER],
            body: { ...form, cloudflareCaptcha },
            successCallback: (response, dispatch) => {
                sessionStorage.removeItem(STORAGE_KEY_CF_TOKEN);
                dispatch(updateInfos(response.payload.user));
                if (callback) {
                    callback();
                }
            },
            errorCallback: () => {
                window.turnstile.reset();
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/authentication/register/actions.js